export { CLTVDashboard } from "./Tabs";
